import { render, staticRenderFns } from "./reel-config.vue?vue&type=template&id=b808aa1e&"
import script from "./reel-config.vue?vue&type=script&lang=js&"
export * from "./reel-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports